import React, { useState, useEffect, useMemo } from 'react';
import { db } from './services/firebase-config';
import { doc, setDoc } from "firebase/firestore";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';

import Carousel from './Components/Carousel';
import ImazenSection from './Components/ImazenSection';
import Loader from './Components/Loader';
import AcceptedModal from './Components/Modals/AcceptedModal';
import RejectionModal from './Components/Modals/RejectionModal';
import ScrollPrompt from './Components/ScrollPrompt';

import * as images from '.';

const App = () => {
  const images1 = useMemo(() => [
    images.img1, images.img2, images.img3, images.img4, images.img5, images.img6, images.img7, images.img8,
    images.img17, images.img18, images.img19, images.img20, images.img21, images.img22, images.img23, images.img24
  ], []);

  const images2 = useMemo(() => [
    images.img9, images.img10, images.img11, images.img12, images.img13, images.img14, images.img15, images.img16,
    images.img25, images.img26, images.img27, images.img28, images.img29, images.img30, images.img31
  ], []);

  const images3 = useMemo(() => [
    images.img17, images.img18, images.img19, images.img20, images.img21, images.img22, images.img23, images.img24,
    images.img1, images.img2, images.img3, images.img4, images.img5, images.img6, images.img7, images.img8, images.img32
  ], []);

  const images4 = useMemo(() => [
    images.img25, images.img26, images.img27, images.img28, images.img29, images.img30, images.img31, images.img9,
    images.img10, images.img11, images.img12, images.img13, images.img14, images.img15, images.img16
  ], []);

  const [showImazen, setShowImazen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [showCelebration, setShowCelebration] = useState(false);
  const [showRejectionPopup, setShowRejectionPopup] = useState(false);
  const [imagesLoaded, setImagesLoaded] = useState(false);
  const [loadedCount, setLoadedCount] = useState(0);
  const [popupEmail, setPopupEmail] = useState('');
  const [isSpecialPopup, setIsSpecialPopup] = useState(false);
  const [isOppsPopup, setIsOppsPopup] = useState(false);
  const totalCount = images1.length + images2.length + images3.length + images4.length;

  useEffect(() => {
    const allImages = [...images1, ...images2, ...images3, ...images4];
    let loaded = 0;
    allImages.forEach((img) => {
      const image = new Image();
      image.src = img;
      image.onload = () => {
        loaded++;
        setLoadedCount(loaded);
        if (loaded === allImages.length) {
          setImagesLoaded(true);
        }
      };
    });
  }, [images1, images2, images3, images4]);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 900);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const handleImageClick = (img) => {
    if (img === images.img31) {
      setShowCelebration(true);
      setIsSpecialPopup(true);
    } else {
      setIsOppsPopup(true);
      setShowRejectionPopup(true);
    }
  };

  const handleEmailSubmit = async (email, special) => {
    if (!email) return;

    try {
      const ref = doc(db, "emails", "xbgV7N2qDecElEfgC", "users", email);
      await setDoc(ref, { email, special, timestamp: new Date() });

      toast.success("Email submitted!");
      setPopupEmail('');
      setShowCelebration(false);
    } catch (err) {
      console.error("Firestore error:", err);
      toast.error("Submission failed. Try again.");
    }
  };

  const handleScrollToImazen = () => {
    setShowImazen(true);
    setTimeout(() => {
      document.querySelector('.imazen-side')?.scrollIntoView({ behavior: 'smooth' });
    }, 50);
  };

  return !imagesLoaded ? (
    <Loader progress={(loadedCount / totalCount) * 100} />
  ) : (
    <div className="app-container">
      <div className="main-flex-layout">
        <section className="carousel-side">
          <div className="carousels">
            <Carousel images={images1} reverse={false} onImageClick={handleImageClick} />
            <Carousel images={images2} reverse={true} onImageClick={handleImageClick} />
            <Carousel images={images3} reverse={false} onImageClick={handleImageClick} />
            <Carousel images={images4} reverse={true} onImageClick={handleImageClick} />
          </div>
          {isMobile && !showImazen && <ScrollPrompt onClick={handleScrollToImazen} />}
        </section>

        <ImazenSection
          visible={!isMobile || showImazen}
          onReject={() => setShowRejectionPopup(true)}
          onAccept={() => {
            setShowCelebration(true);
            setIsSpecialPopup(false);
          }}
        />

        <AcceptedModal
          open={showCelebration}
          onClose={() => setShowCelebration(false)}
          isSpecial={isSpecialPopup}
          email={popupEmail}
          setEmail={setPopupEmail}
          onSubmit={handleEmailSubmit}
        />

        <RejectionModal
          open={showRejectionPopup}
          onClose={() => {
            setShowRejectionPopup(false);
            setIsOppsPopup(false);
          }}


          message={isOppsPopup}
        />
      </div>

      <ToastContainer position="top-right" />
    </div>
  );
};

export default App;
